import { AfterViewInit, Component } from '@angular/core';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

@Component({
  selector: 'app-trustpilot-wide',
  templateUrl: './trustpilot-wide.component.html',
  styleUrls: ['./trustpilot-wide.component.sass']
})
export class TrustpilotWideComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    // Find the trustpilot widget div and initialize it
    const trustBoxRef = document.querySelector('.trustpilot-widget');
    if (trustBoxRef && window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustBoxRef);
    }
  }
}
